import React, {useEffect, useRef} from 'react';
import {Column} from 'devextreme-react/data-grid';
import {Item as TabItem} from "devextreme-react/tab-panel";
import Form, {FormRef, GroupItem, SimpleItem} from "devextreme-react/form";
import ILangue from '../../models/ILangue';
import {FormListBase, FormListBaseGrid, FormListBaseTab, FormListBaseToolbar} from '../base';
import useCustomDataSource, {Mode} from "../../hooks/useCustomDataSource";
import FormSysteme from '../../components/forms/form-systeme';

interface IConfigurationLanguesProps {
    isModeSelection?: boolean,
}

export default function ConfigurationLangues({isModeSelection}: IConfigurationLanguesProps) {
    const langueFormDataSource = useCustomDataSource<ILangue, ILangue>({path: "langue", primaryKey: "idLangue"});
    const {setMainForm, selectedDataRow: selectedLangue, mode, setMode, isFieldModifier, onFieldDataChanged} = langueFormDataSource;
    const formRef = useRef<FormRef>(null);

    useEffect(() => {
        setMainForm(formRef.current?.instance());
    })

    useEffect(() => {
        if (mode !== Mode.Lecture) formRef.current?.instance().getEditor("description")?.focus();
    }, [mode])

    return (
        <FormListBase data={langueFormDataSource}>
            <FormListBaseGrid dataSource={langueFormDataSource.dataSource} onFocusedRowChanged={() => {
                if (mode === Mode.Modifier) {
                    setMode(Mode.Lecture);
                }
            }}>
                <Column key={"grid-col-description"} dataField={"description"} caption="Description" allowHiding={false}/>
            </FormListBaseGrid>
            <FormListBaseToolbar removeBlocked={true} headerText={`${selectedLangue?.description || ''}`} sauvegarderOptions={{disabled: !isFieldModifier}} annulerOptions={{disabled: !isFieldModifier}} effacerOptions={{visible: false, disabled: !isFieldModifier}}/>
            {!isModeSelection || isModeSelection && mode !== Mode.Lecture
                ? <FormListBaseTab>
                    <TabItem title="Informations">
                        <Form ref={formRef} readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedLangue || {} as ILangue} className={"forms"} labelLocation={"left"} showColonAfterLabel={true} onFieldDataChanged={onFieldDataChanged}>
                            <GroupItem>
                                <SimpleItem key={"frm-description"} dataField={"description"}/>
                                <SimpleItem key={"frm-code"} dataField={"code"}/>
                            </GroupItem>
                        </Form>
                    </TabItem>
                    <TabItem title="Système"><FormSysteme formData={selectedLangue || {} as ILangue}/></TabItem>
                </FormListBaseTab> : null}
        </FormListBase>
    );
}